import gql from 'graphql-tag'

export const GET_USER_SUBSCRIPTION = gql`
  query GetUserSubscriptions($input: GetUserSubscriptionsInput!) {
    getUserSubscriptions(input: $input)
  }
`
